import { Modal } from '@mui/material';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { A11yProps, TabPanel } from '../../components';
import { Loading } from '../../components/Loading';
import { TitleBar } from '../../components/TitleBar';
import { createSubActivity } from '../../models/subActivities';
import { RootState, getSubActivity, useAppDispatch, useAppSelector } from '../../redux';
import { MyBoxModal } from '../../styled-components';
import { Courses } from '../courses';
import { Groups } from '../groups';
import { Materials } from '../materials';
import { MyForm } from './components';

export const SubActivityItems = () => {
    const { id } = useParams();
    const [value, setValue] = useState(0);

    const dispatch = useAppDispatch();
    const { isLoading, subActivity } = useAppSelector((state: RootState) => state.subActivities);

    useEffect(() => {
        if (id)
            dispatch(getSubActivity(id));
    }, [dispatch, id])

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const [dialogOpen, setDialogOpen] = useState(false);
    const openDialog = () => setDialogOpen(!dialogOpen);
    const [editing, setEditing] = useState(false);
    const [subActivityToEdit, setSubActivityToEdit] = useState(createSubActivity({}));
    const onEdit = () => {
        setSubActivityToEdit(createSubActivity(subActivity));
        setEditing(true);
        openDialog();
    }

    return (
        <div>
            <Loading isLoading={isLoading} />
            <TitleBar onEdit={onEdit} title={`Sub Activity: ${subActivity.name}`} urlToBack='/subactivities/' />
            <br />
            <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={value} onChange={handleChange}>
                        <Tab label="Materials" {...A11yProps(0)} />
                        <Tab label="Groups" {...A11yProps(1)} />
                        <Tab label="Courses" {...A11yProps(2)} />
                    </Tabs>
                </Box>
                <TabPanel value={value} index={0}>
                    <Materials isToAddMaterials={true} entity="subActivities" idParent={id} />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <Groups isToAddGroups={true} idParent={id} />
                </TabPanel>
                <TabPanel value={value} index={2}>
                    <Courses isToAddCourses={true} idParent={id} />
                </TabPanel>
            </Box>
            <Modal open={dialogOpen} onClose={openDialog}>
                <MyBoxModal>
                    <MyForm onCancel={openDialog} subActivity={subActivityToEdit} editing={editing} />
                </MyBoxModal>
            </Modal>
        </div>
    );
}
